import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import ActionData from "csi/heading/ActionData";
import StringRen from "csi/heading/String";
import declare from "dojo/_base/declare";
import { pathCreate } from "csi/utility/pathUtility";

const CompositionStringRenderer = declare(StringRen, {
	/**
	 * @override
	 * Add any dependency paths required by renderer class
	 */
	addRendererDependencyPaths: function(h: Heading, paths: string[]): void { 
		paths.push(pathCreate(h.getClassPath(), "TechnicalComposition"));
	},

	/**
	 * @override
	 * Action will be used for tooltip
	 */
	_getRenderAction: function(ctx: Context, h: Heading): ActionData {
		const ad = this.inherited<ActionData>(arguments);
		if (ad) {
			ad.bTooltip = true;
		}
		return ad;
	},
});

export = CompositionStringRenderer;